<template>
  <!-- eslint-disable vue/no-v-model-argument -->
  <div class="m-t-10 m-b-10">
    <input id="accepted-terms-at" type="hidden" name="accepted_terms_at" :value="acceptedTermsAt" />
    <label data-test="accept-contract-terms">
      <WdsCheckbox
        v-model:checked="isAccepted"
        :value="isAccepted"
        :disabled="disabled"
        name="accepted_terms"
        required
      >
        <i class="input-helper" />
        <template v-if="acceptingNewContract">
          {{
            $t(
              `By checking the box and clicking “Accept new contract” you agree to be legally bound by the terms and conditions.*`,
            )
          }}
        </template>
        <template v-else-if="signatureWaived">
          {{
            $t(
              `By checking the box and clicking “Accept contract,” you agree to be legally bound by the terms and conditions.*`,
            )
          }}
        </template>
        <template v-else>
          {{
            $t(
              `By checking the box and clicking “Accept and sign contract,” you agree to be legally bound by the terms and conditions.*`,
            )
          }}
        </template>
      </WdsCheckbox>
    </label>
  </div>
</template>

<script>
import { WdsCheckbox } from '@worksome/wds-components'
import moment from 'moment'

export default {
  name: 'ContractFormAcceptTermInput',

  components: {
    WdsCheckbox,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },

    value: {
      type: Boolean,
      default: false,
    },

    acceptingNewContract: {
      type: Boolean,
      default: false,
    },

    // The contract is confirmed without a signature (supplier signature
    // waived), so the label must not mention signing.
    signatureWaived: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isAccepted: this.value,
    }
  },

  computed: {
    acceptedTermsAt() {
      this.$emit('accepted', this.isAccepted)
      return this.isAccepted ? moment().format('YYYY-MM-DD hh:mm:ss') : null
    },
  },
}
</script>
